import { useLanguage } from '../contexts/LanguageContext';
import { fr } from '../translations/fr';
import { en } from '../translations/en';
import { de } from '../translations/de';
import { nl } from '../translations/nl';

const translations = {
  fr,
  en,
  de,
  nl,
};

export function useTranslation() {
  const { language } = useLanguage();
  const t = translations[language] || translations.fr;

  const translate = (key, params = {}) => {
    const keys = key.split('.');
    let value = t;
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        // Si defaultValue est fourni, l'utiliser comme fallback
        if (params.defaultValue !== undefined) {
          return params.defaultValue;
        }
        return key;
      }
    }

    if (typeof value === 'string') {
      // Remplacer les paramètres {param} dans la chaîne
      return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
        return params[paramKey] !== undefined ? params[paramKey] : match;
      });
    }

    // Si defaultValue est fourni et que la valeur n'est pas une string, l'utiliser
    if (params.defaultValue !== undefined) {
      return params.defaultValue;
    }

    return value;
  };

  return { t: translate, language };
}

